export default __webpack_public_path__ + "static/media/FengLoaderPNGFull.b7cc6483.png";